import { render } from "./UncappedSearchFromPage.vue?vue&type=template&id=59b61b65"
import script from "./UncappedSearchFromPage.vue?vue&type=script&lang=js"
export * from "./UncappedSearchFromPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__